import React from "react";
import { Select, DatePicker, Row, Col } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { WEBHOOK_TYPES } from "constants/webhook";
import WebhookWidget from "./WebhookWidget";
const { RangePicker } = DatePicker;

const WebhookLogListWidget = ({
  logsData = [],
  selectedId,
  onSelectLog,
  webhookName,
  link,
}) => {
  const { t: translate } = useTranslation();
  return (
    <div className="w-100">
      {/* --- PHẦN FILTER --- */}
      <Row gutter={[8, 8]} className="mb-3">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <p>
            <span className="font-weight-bold text-dark text-truncate mr-2">{translate("webhook.name")}:</span>
            <span className="text-primary">{webhookName || ""}</span>
          </p>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <p>
            <span className="font-weight-bold text-dark text-truncate mr-2">
              {translate("webhook.link")}:{" "}
            </span>
            <span className="text-primary">{link || ""}</span>
          </p>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Select
            mode="multiple"
            allowClear
            className="w-100"
            placeholder={translate("webhook.status")}
            options={[
              { label: translate("webhook.success"), value: "success" },
              { label: translate("webhook.failed"), value: "failed" },
            ]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Select
            className="w-100"
            placeholder={translate("webhook.duration")}
            allowClear
            options={[
              { label: "1-5 giây", value: "1-5s" },
              { label: "5-10 giây", value: "5-10s" },
              { label: "10-30 giây", value: "10-30s" },
              { label: ">30 giây", value: ">30s" },
            ]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Select
            className="w-100"
            mode="multiple"
            placeholder={translate("webhook.type")}
          >
            {WEBHOOK_TYPES.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {translate(`${option.label}`)}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <RangePicker
            className="w-100"
            placeholder={[
              translate("webhook.startDate"),
              translate("webhook.endDate"),
            ]}
            format="DD-MM-YYYY"
            defaultValue={[moment().startOf("day"), moment().endOf("day")]}
          />
        </Col>
      </Row>

      {/* --- PHẦN DANH SÁCH LOG (DÙNG FLEX CONTAINER ĐỂ KHÔNG BAO GIỜ ĐÈ NHAU) --- */}
      <div
        className="d-flex flex-column"
        style={{
          maxHeight: "75vh", // Hoặc cố định một chiều cao cụ thể
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {logsData.map((item) => {
          const isSelected = item.id === selectedId;
          return (
            <WebhookWidget
              key={item.id}
              item={item}
              isSelected={isSelected}
              onSelectLog={onSelectLog}
            />
          );
        })}
      </div>
    </div>
  );
};

export default WebhookLogListWidget;
